/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
export default function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/hasClass.js
// module id = 1197
// module chunks = 0